<app-page-title title="Devocional"></app-page-title>
<mat-progress-bar mode="indeterminate" *ngIf="showLoader"></mat-progress-bar>

<div class="view-container" *ngIf="quiz">
  <div class="header-actions">
    <button class="btn-secundary" [routerLink]="['/devocional']">Voltar</button>
  </div>

  <div class="quiz-content-card">
    <div class="quiz-header">
      <h2 class="quiz-title">{{ quiz.title }}</h2>
      <div class="status-date" [ngClass]="{ expired: isExpired(quiz.end_date) }">
        <mat-icon>event</mat-icon>
        <span
          >{{ isExpired(quiz.end_date) ? 'Encerrou em:' : 'Encerra em:' }}
          {{ quiz.end_date | date : 'dd/MM/yyyy' }}</span
        >
      </div>
    </div>

    <div class="quiz-body">
      <p class="quiz-text">{{ quiz.text }}</p>
    </div>

    <!-- Accordion: Minhas Respostas -->
    <div class="my-answers-section" *ngIf="quiz.my_answered">
      <mat-accordion>
        <mat-expansion-panel class="custom-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="check-icon">check_circle</mat-icon>
              <span>Minhas Respostas</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="qa-item">
            <p class="question">{{ quiz.question_1 }}</p>
            <p class="answer">{{ quiz.my_answered.answer_1 || 'Não respondida' }}</p>
          </div>
          <div class="qa-item">
            <p class="question">{{ quiz.question_2 }}</p>
            <p class="answer">{{ quiz.my_answered.answer_2 || 'Não respondida' }}</p>
          </div>
          <div class="qa-item">
            <p class="question">{{ quiz.question_3 }}</p>
            <p class="answer">{{ quiz.my_answered.answer_3 || 'Não respondida' }}</p>
          </div>
          <div class="qa-item">
            <p class="question">{{ quiz.question_4 }}</p>
            <p class="answer">{{ quiz.my_answered.answer_4 || 'Não respondida' }}</p>
          </div>
          <div class="qa-item">
            <p class="question">{{ quiz.question_5 }}</p>
            <p class="answer">{{ quiz.my_answered.answer_5 || 'Não respondida' }}</p>
          </div>

          <!-- Feedback do Revisor (se houver) -->
          <div class="feedback-section" *ngIf="quiz.my_answered.reviewer?.feedback">
            <div class="feedback-header">
              <div class="reviewer-info">
                <span class="reviewed-badge">Revisado por</span>
                <div class="avatar-circle micro">
                  <img *ngIf="quiz.my_answered.reviewer.avatar" [src]="getAvatarUrl(quiz.my_answered.reviewer.avatar)" />
                  <div *ngIf="!quiz.my_answered.reviewer.avatar" class="avatar-initial">
                    {{ getFirstLetter(quiz.my_answered.reviewer.name || 'Líder') }}
                  </div>
                </div>
                <span class="reviewer-name">{{ formatShortName(quiz.my_answered.reviewer.name || 'Líder') }}</span>
              </div>
            </div>
            <div class="feedback-body">
              <p class="feedback-text">"{{ quiz.my_answered.reviewer.feedback }}"</p>
            </div>
          </div>

          <div class="edit-answer-action" *ngIf="!isExpired(quiz.end_date)">
            <button class="btn-secundary" [routerLink]="['/devocional/respond', quiz.id]">Editar Resposta</button>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <!-- Quem já respondeu (Stacked Avatars) -->
    <div class="respondents-summary" *ngIf="quiz.answered_by && quiz.answered_by.length > 0">
      <div class="avatars-stacked">
        <div class="avatar-circle" *ngFor="let res of quiz.answered_by | slice : 0 : 3">
          <img *ngIf="res.avatar" [src]="getAvatarUrl(res.avatar)" [matTooltip]="res.name" />
          <div *ngIf="!res.avatar" class="avatar-initial" [matTooltip]="res.name">{{ getFirstLetter(res.name) }}</div>
        </div>
      </div>
      <span class="respondents-text" *ngIf="quiz.answered_by.length > 3">
        + {{ quiz.answered_by.length - 3 }} outros responderam
      </span>
      <span class="respondents-text" *ngIf="quiz.answered_by.length <= 3"> já responderam </span>
    </div>

    <!-- Ações / Rodapé -->
    <div class="footer-actions">
      <div *ngIf="!quiz.my_answered && !isExpired(quiz.end_date)" class="w-100 flex-center">
        <button class="btn-primary" [routerLink]="['/devocional/respond', quiz.id]">Responder Quiz</button>
      </div>

      <div *ngIf="!quiz.my_answered && isExpired(quiz.end_date)" class="expired-notice">
        <mat-icon>info</mat-icon>
        <p>Este quiz já encerrou e não pode mais ser respondido.</p>
      </div>
    </div>
  </div>

  <!-- Lista detalhada para os Líderes revisarem -->
  <div class="members-list-card" *ngIf="quiz.answered_to_review && quiz.answered_to_review.length > 0">
    <h3 class="section-title">Respostas dos Membros</h3>
    <mat-divider></mat-divider>

    <div class="member-list">
      <div class="member-item" *ngFor="let member of quiz.answered_to_review">
        <div class="member-info">
          <div class="avatar-circle small">
            <img *ngIf="member.avatar" [src]="getAvatarUrl(member.avatar)" />
            <div *ngIf="!member.avatar" class="avatar-initial">{{ getFirstLetter(member.name) }}</div>
          </div>
          <span class="member-name">{{ formatShortName(member.name) }}</span>

          <div class="reviewer-info" *ngIf="member?.reviewer?.feedback">
            <span class="reviewed-badge">Revisado por</span>
            <div class="avatar-circle micro">
              <img
                *ngIf="member.reviewer.avatar"
                [src]="getAvatarUrl(member.reviewer.avatar)"
                [matTooltip]="member.reviewer.name || 'Líder'"
              />
              <div
                *ngIf="!member.reviewer.avatar"
                class="avatar-initial"
                [matTooltip]="member.reviewer.name || 'Líder'"
              >
                {{ getFirstLetter(member.reviewer.name || 'Líder') }}
              </div>
            </div>
            <span class="reviewer-name">{{ formatShortName(member.reviewer.name || 'Líder') }}</span>
          </div>
        </div>

        <button
          class="btn-review"
          [routerLink]="['/devocional/review', member.answer_id]"
          *ngIf="!member?.reviewer?.feedback"
        >
          Revisar
        </button>
      </div>
    </div>
  </div>
</div>
